/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UtilizationMetricsAggregateResult {
    getFixupPrototypeFunction() { return UtilizationMetricsAggregateResult.fixupPrototype; }

    static newInstance(model: Partial<UtilizationMetricsAggregateResult>): UtilizationMetricsAggregateResult {
        let obj = Object.assign(new UtilizationMetricsAggregateResult(), model);
        UtilizationMetricsAggregateResult.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UtilizationMetricsAggregateResult>): UtilizationMetricsAggregateResult {
        if (!model) return null;
        return UtilizationMetricsAggregateResult.newInstance(<UtilizationMetricsAggregateResult> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UtilizationMetricsAggregateResult) {
        if (!obj) return;

        models.UtilizationMetricsAggregateResult.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UtilizationMetricsAggregateResult): boolean {
        Object.setPrototypeOf(obj, UtilizationMetricsAggregateResult.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.identity) {
            models.UtilizationMetricIdentity.fixupPrototype(this.identity);
        }
        if (this.metric_series) {
            models.UtilizationMetricSeries.fixupPrototype(this.metric_series);
        }
        if (this.timestamps) {
            for (let i = 0; i < this.timestamps.length; i++) {
                let val = this.timestamps[i];
                if (typeof val === "string") {
                    this.timestamps[i] = new Date(<string><any>val);
                }
            }
        }
    }

    /**
     * Identity of the result group.
     */
    identity: models.UtilizationMetricIdentity;

    /**
     * Statistical summary of utilization metric data.
     */
    metric_series: models.UtilizationMetricSeries;

    /**
     * timestamps
     */
    timestamps: Array<Date>;

}
